import React, { useEffect, useState } from "react";
import moment from "moment";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import OnlinePayment from "./OnlinePayment";
import CashPayment from "./CashPayment";
import okIcon from "../../assets/ok_icon.svg";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import CheckboxWithText from "../common/Modules/CheckboxWithText";
import FormInputWithHeader from "../common/FormInputWithHeader";
import { UPDATE_CONSULTATION } from "./APIHandler/apiConstants";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import Loader from "../UI Component/Loader/Loader";
import { BOOKING_TYPE } from "./Constants";

export default function ReviewAndShare(props) {
  const {
    hasResourceAccess,
    orderId,
    procedureAppointmentId,
    existingOrderId,
    addBooking,
    paymentMethod,
    selectedBookingType,
    appointmentData,
    handleSetAppointmentType,
  } = props;
  const [hasAppliedDiscount, setHasAppliedDiscount] = useState(false);
  const [discountInput, setDiscountInput] = useState(0);

  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [feeDetails, setFeeDetails] = useState({});

  const [isOnlinePayment, setIsOnlinePayment] = useState(true);

  const [showTimer, setShowTimer] = useState(false);
  const [counter, setCounter] = useState(30);
  const [loader, setLoader] = useState(true);
  const [phno, setPhno] = useState("");
  const [count, setCount] = useState(0);
  const [btnClicked, setBtn] = useState(false);
  const [proceedBtn, setProceedBtn] = useState(true);
  const [disabledProceedBtn, setDisabledProceedBtn] = useState(false);
  // Get consultation details when page loads based on Appointment Id
  const [checkboxValue, setCheckboxValue] = useState([
    {
      id: "1",
      name: "+5%",
      value: 5,
      checked: false,
    },
    {
      id: "2",
      name: "+10%",
      value: 10,
      checked: false,
    },
    {
      id: "3",
      name: "+15%",
      value: 15,
      checked: false,
    },
  ]);

  // Varible
  let isStaff = localStorage.getItem("user_type");
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const [isPartialPaymentSelected, setIsPartialPaymentSelected] =
    useState(false);
  const [partialAmount, setPartialAmount] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [sendBtnDisabled, setSendBtnDisabled] = useState(false);
  const [appliedFields, setAppliedFields] = useState({
    appliedDiscount: 0,
    appliedPartialAmount: "",
  });
  const [procedureFeeList, setProcedureFeeList] = useState([]);
  const [fullPageLoader, setFullPageLoader] = useState(false);
  let colClasses = "col-lg-8 col-12 m-auto ";

  useEffect(() => {
    let quoteDiscount = appointmentData?.discount_percentage
      ? Number(appointmentData?.discount_percentage)
      : "";
    setDiscountInput(quoteDiscount);
    setHasAppliedDiscount(quoteDiscount ? true : false);

    if (
      (props.selectedSlotObj?.is_walkin ||
        props.appointmentType === "in-clinic") &&
      paymentMethod !== "online"
    ) {
      setIsOnlinePayment(false);
      handleCashPaymentClick("firstTime", quoteDiscount);
    } else {
      if (isOnlinePayment === true) {
        setProceedBtn(true);
      } else {
        setProceedBtn(false);
      }
      PaymentMode("online", quoteDiscount);
    }
    if (window.innerWidth > 768) {
      colClasses += "pr-0";
    }
  }, []);

  // Timer Effect
  useEffect(() => {
    if (btnClicked === true) {
      const timer = setTimeout(() => {
        if (counter > 0) {
          setCounter(counter - 1);
        } else {
          setCount(count + 1);
          setShowTimer(false);
        }
      }, 1000);
      // Clear timeout if the component is unmounted
      return () => clearTimeout(timer);
    }
  }, [counter, btnClicked]);

  function PaymentMode(mode, quoteDiscount) {
    let payload = {
      ...(!hasResourceAccess && { appointment_id: props.appointmentId }),
      payment_method: mode,
      ...((hasResourceAccess ||
        (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) && {
        order_id: orderId,
      }),
    };

    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "/clinic/get-inclinic-consultation-details-rev1"
          : "doctor/get-inclinic-consultation-details-rev1",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data) {
          if (
            hasResourceAccess ||
            (addBooking && selectedBookingType == BOOKING_TYPE.LABORATORY)
          ) {
            let procedureList = response?.data?.appointment_details;
            if (procedureList?.length > 0) {
              procedureList.forEach((procedure) => {
                let final_discounted_amount =
                  parseFloat(Number(procedure?.consultation_fees)?.toFixed(2)) +
                  parseFloat(
                    Number(
                      procedure?.custom_gst_in_rupees
                        ? procedure?.custom_gst_in_rupees
                        : 0
                    )?.toFixed(2)
                  );
                procedure["amount_with_gst"] = parseFloat(
                  final_discounted_amount?.toFixed(2)
                );
              });
            }
            setProcedureFeeList(procedureList);
            if (response?.data?.appointment_details?.length > 0) {
              let details = response?.data?.appointment_details;
              setAppointmentDetails({
                patient_name: details[0].patient_name,
                patient_phone: details[0].patient_phone,
                email: details[0].email,
                total_fees: response?.data?.total_fee,
                total_discount: response?.data?.total_discount,
                appointment_date: details[0].appointment_date,
                convenience_fee: response?.data?.convenience_fee,
                gst_price: response?.data?.gst_price,
                is_partial_payment_enabled:
                  details[0].is_partial_payment_enabled,
                custom_gst_in_rupees: response?.data?.custom_gst_in_rupees ?? 0,
              });
              setPhno(details[0].patient_phone);
            }
            if (existingOrderId) {
              let details = response?.data?.appointment_details;
              if (details[0]?.total_discount > 0) {
                setDiscountInput(details[0]?.discount_percent);
                setAppliedFields({
                  ...appliedFields,
                  appliedDiscount: details[0]?.discount_percent, // Removed [0] here
                });
                setHasAppliedDiscount(true);
              } else {
                setHasAppliedDiscount(false);
              }
            }
            if ((discountInput && hasAppliedDiscount) || quoteDiscount) {
              applyDiscount(mode, quoteDiscount);
            } else {
              let conultationFees = response?.data?.appointment_details.reduce(
                (a, v) => (a = a + (v?.consultation_fees ?? 0)),
                0
              );
              let fees = {
                consultation_fees: conultationFees,
                total_discount: response?.data?.total_discount,
                total_fees: response?.data?.total_fee,
                rounded_value: response?.data?.rounded_value,
                gst_price: response?.data?.total_gst_fee,
                partial_amount: response?.data?.partial_amount ?? "",
                pending_amount: response?.data?.pending_amount ?? "",
                convenience_fee: response?.data?.total_convenience_fee,
                custom_gst_in_rupees: response?.data?.custom_gst_in_rupees ?? 0,
              };
              setFeeDetails(fees);
            }
            if (response?.data?.partial_amount) {
              setIsPartialPaymentSelected(true);
              setPartialAmount(response?.data?.partial_amount);
              setAppliedFields({
                ...appliedFields,
                appliedPartialAmount: response.data?.partial_amount,
              });
            }
          } else {
            setPhno(response.data.patient_phone);
            setAppointmentDetails(response.data);
            if (response.data?.total_discount > 0) {
              setDiscountInput(response.data?.discount_percent);
              setAppliedFields({
                ...appliedFields,
                appliedDiscount: response.data?.discount_percent,
              });
              setHasAppliedDiscount(true);
            } else {
              if (!quoteDiscount) {
                setHasAppliedDiscount(false);
              }
            }
            if ((discountInput && hasAppliedDiscount) || quoteDiscount) {
              applyDiscount(mode, quoteDiscount);
            } else {
              let fees = {
                consultation_fees: response.data.consultation_fees,
                gst_price: response.data.gst_price,
                total_discount: response.data.total_discount,
                convenience_fee: response.data.convenience_fee,
                rounded_amount: response.data.rounded_amount,
                total_fees: response.data.total_fees,
                partial_amount: response.data.partial_amount ?? "",
                pending_amount: response.data.pending_amount ?? "",
                custom_gst_in_rupees: response?.data?.custom_gst_in_rupees ?? 0,
              };
              setFeeDetails(fees);
            }
            if (response?.data?.partial_amount) {
              setIsPartialPaymentSelected(true);
              setPartialAmount(response?.data?.partial_amount);
              setAppliedFields({
                ...appliedFields,
                appliedPartialAmount: response.data?.partial_amount,
              });
            }
          }
          setLoader(false);
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function handleDiscountInputChange(evt) {
    if (evt.target.value <= 100) {
      setDiscountInput(
        evt.target.value != "" ? parseInt(evt.target.value) : ""
      );
    } else {
      alert("Value must be less than or equal to 100 .");
    }
  }

  const handleCheckbox = (e, id) => {
    let arr = checkboxValue;
    arr.map((data, index) => {
      if (data.checked === true) {
        if (data.id !== id) {
          data.checked = false;
        }
        setCheckboxValue([...arr]);
      } else if (data.id == id) {
        if (data.value + +discountInput <= 100) {
          data.checked = e.target.checked;
          setCheckboxValue([...arr]);
          setDiscountInput(data.value + +discountInput);
        } else {
          alert("Value must be less than or equal to 100 .");
        }
      }
    });
  };

  function applyDiscount(val, quoteDiscount) {
    let tempDiscountInput = quoteDiscount ? quoteDiscount : discountInput;
    if (tempDiscountInput <= 100) {
      let discountedAmount =
        +feeDetails?.consultation_fees * (+tempDiscountInput / 100);
      if (
        +appliedFields?.appliedPartialAmount <
          +feeDetails?.consultation_fees - +discountedAmount ||
        +appliedFields?.appliedPartialAmount <= 0
      ) {
        setErrorMsg("");
        setSendBtnDisabled(false);
        setAppliedFields({
          ...appliedFields,
          appliedDiscount: tempDiscountInput,
        });
        if (val !== "cash" || quoteDiscount) {
          callDiscountApi(
            val,
            tempDiscountInput,
            appliedFields?.appliedPartialAmount
          );
        }
      } else {
        setErrorMsg(
          "Partial amount should be more than 0 and less than consultation fees"
        );
        setSendBtnDisabled(true);
      }

      getCalculatedProcedureFeeList(tempDiscountInput);
    } else {
      alert("Value must be less than or equal to 100 .");
    }
  }

  function removeDiscount() {
    callDiscountApi("", 0, appliedFields?.appliedPartialAmount);
    setDiscountInput(0);
    setAppliedFields({ ...appliedFields, appliedDiscount: 0 });
    setHasAppliedDiscount(false);
    checkboxValue.forEach((data) => {
      data.checked = false;
    });
    getCalculatedProcedureFeeList(0);
  }

  const getCalculatedProcedureFeeList = (discount = 0) => {
    if (procedureFeeList?.length > 0) {
      let discountOnEachProcedure = discount;
      procedureFeeList.forEach((data) => {
        let discount_in_rupee =
          +data?.consultation_fees * (+discountOnEachProcedure / 100);
        let customGst = (+data?.sgst_in_percent + +data?.cgst_in_percent) / 100;
        let discounted_amount = +data?.consultation_fees - discount_in_rupee;
        let customGstInRupees = Number(discounted_amount) * customGst;
        let final_discounted_amount =
          parseFloat(discounted_amount.toFixed(2)) +
          parseFloat(customGstInRupees.toFixed(2));
        data["amount_with_gst"] = parseFloat(
          final_discounted_amount?.toFixed(2)
        );
        data["custom_gst_in_rupees"] = parseFloat(customGstInRupees.toFixed(2));
      });
      setProcedureFeeList(procedureFeeList);
    }
  };
  function handleOnlinePaymentClick() {
    setProceedBtn(true);
    setIsOnlinePayment(true);
    setFullPageLoader(true);
    callDiscountApi("online", appliedFields?.appliedDiscount, 0);
  }

  function handleCashPaymentClick(firstTime, quoteDiscount) {
    if (firstTime === "firstTime") {
      PaymentMode("cash", quoteDiscount);
    } else {
      setFullPageLoader(true);
      callDiscountApi("cash", appliedFields?.appliedDiscount, 0);
    }
    setIsPartialPaymentSelected(false);
    setPartialAmount("");
    setAppliedFields({
      ...appliedFields,
      appliedPartialAmount: 0,
    });
    setErrorMsg("");
    setSendBtnDisabled(false);
    setProceedBtn(false);
    setIsOnlinePayment(false);
    setShowTimer(false);
    setCounter(0);
  }

  function handlePhoneOnChange(evt) {
    setPhno(evt.target.value);
    setAppointmentDetails({
      ...appointmentDetails,
      patient_phone: evt.target.value,
    });
  }

  function sendSMS() {
    setProceedBtn(false);
    setBtn(true);
    setShowTimer(true);
    setCounter(30);
    let payload = {
      payment_method: "online", //isOnlinePayment?'online':'cash'
      discount: +appliedFields?.appliedDiscount,
      partial_amount: +appliedFields?.appliedPartialAmount,
      appointment_id:
        (hasResourceAccess ||
          (addBooking && selectedBookingType == BOOKING_TYPE.LABORATORY)) &&
        procedureAppointmentId
          ? procedureAppointmentId
          : props.appointmentId,
      staff_id: `${isStaff === "staff" ? staffId : ""}`,
      age: appointmentDetails.age,
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "clinic/update-inclinic-consultation"
          : "doctor/update-inclinic-consultation",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          SendLink();
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function SendLink() {
    let payload = {
      phone_no: "+91" + appointmentDetails.patient_phone,
      user_type: localStorage.getItem("user_type"),
      user_id: getUserId(),
      appointment_id: props.appointmentId,
      consultation_method:
        props.appointmentType === "online" ? "online" : "inclinic",
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "/clinic/inclinic-send-sms"
          : "doctor/inclinic-send-sms",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          C2CConsole.log("success");
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function handleSubmitClick() {
    props.submitCallback(appointmentDetails);
    props.closeModel(null, true);
    handleSetAppointmentType(isOnlinePayment);
  }

  function handleViaCash() {
    setDisabledProceedBtn(true);
    let payload = {
      payment_method: "cash",
      discount: discountInput,
      appointment_id: props.appointmentId,
      ...((hasResourceAccess ||
        (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) && {
        appointment_id: procedureAppointmentId,
      }),
      staff_id: `${isStaff === "staff" ? staffId : ""}`,
      age: appointmentDetails.age,
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "clinic/update-inclinic-consultation"
          : "doctor/update-inclinic-consultation",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          handleSubmitClick();
          setDisabledProceedBtn(false);
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
          setDisabledProceedBtn(false);
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  const handleResoureSubmit = () => {
    setDisabledProceedBtn(true);
    let payload = {
      payment_method: isOnlinePayment ? "online" : "cash",
      discount: discountInput,
      staff_id: `${isStaff === "staff" ? staffId : ""}`,
      order_id: orderId,
      partial_amount: partialAmount,
      "authorizer-principal-id": {
        user_type: isStaff === "staff" ? "4" : "1",
        user_id: isStaff === "staff" ? staffId : userId,
        agent: "Web",
      },
      appointment_id: props.appointmentId,
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url: UPDATE_CONSULTATION,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setDisabledProceedBtn(false);
          setProceedBtn(false);
          if (isOnlinePayment) {
            setShowTimer(true);
            setBtn(true);
            setCounter(30);
            SendLink();
          } else {
            handleSubmitClick();
          }
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
          setDisabledProceedBtn(false);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  // This is required to handle the staff login to store audit information in the database.
  function getUserId() {
    if (localStorage.getItem("user_type") === "staff") {
      return staffId;
    } else {
      return userId;
    }
  }

  // Helper Methods ===>

  const callDiscountApi = (val, discount, partialPayment) => {
    afterLoginApiAxios
      .post(
        "doctor/inclinic-consultation-apply-discount-rev1",
        {
          appointment_id: props.appointmentId,
          discount: +discount,
          partial_amount: +partialPayment,
          payment_method: val ? val : isOnlinePayment ? "online" : "cash",
          ...((hasResourceAccess ||
            (addBooking &&
              selectedBookingType === BOOKING_TYPE.LABORATORY)) && {
            order_id: orderId,
          }),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data.statusCode == 200) {
          if (
            hasResourceAccess ||
            (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)
          ) {
            if (response.data?.data?.total_discount > 0) {
              setHasAppliedDiscount(true);
            } else {
              setHasAppliedDiscount(false);
            }
            let data = response.data?.data;
            let fees = {
              consultation_fees: data?.consultation_fees,
              total_discount: data?.total_discount,
              total_fees: data?.total_fees,
              gst_price: data?.gst_price,
              partial_amount: data?.partial_amount,
              convenience_fee: data?.convenience_fee,
              pending_amount: data?.pending_amount,
              custom_gst_in_rupees: data?.custom_gst_in_rupees ?? 0,
            };
            setPartialAmount(
              data?.partial_amount > 0 ? data?.partial_amount : ""
            );
            setFeeDetails({ ...feeDetails, ...fees });
            setLoader(false);
            setFullPageLoader(false);
          } else {
            if (response.data?.data?.total_discount > 0) {
              setHasAppliedDiscount(true);
            } else {
              setHasAppliedDiscount(false);
            }
            let data = response.data?.data;
            let fees = {
              consultation_fees: data?.consultation_fees,
              gst_price: data?.gst_price,
              total_discount: data?.total_discount,
              convenience_fee: data?.convenience_fee,
              rounded_amount: data?.rounded_amount,
              total_fees: data?.total_fees,
              partial_amount: data?.partial_amount ?? "",
              pending_amount: data?.pending_amount ?? "",
              custom_gst_in_rupees: data?.custom_gst_in_rupees ?? 0,
            };
            setFeeDetails({ ...response.data.data, ...fees });
            setLoader(false);
            setFullPageLoader(false);
          }
        } else {
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  // <===

  // Actions ===>

  const handleChangePartialPaymentCheckbox = () => {
    let show = !isPartialPaymentSelected;
    setIsPartialPaymentSelected(show);
    if (!show) {
      setPartialAmount("");
      setErrorMsg("");
      setSendBtnDisabled(false);
      setAppliedFields({ ...appliedFields, appliedPartialAmount: 0 });
      callDiscountApi("", appliedFields?.appliedDiscount, 0);
    } else {
      setSendBtnDisabled(true);
    }
  };

  const handleChangePartialAmount = (e) => {
    setPartialAmount(e.target.value);
  };

  const applyPartialPayment = () => {
    let maxAmount =
      +feeDetails.total_discount > 0
        ? +feeDetails.consultation_fees - +feeDetails.total_discount
        : +feeDetails.consultation_fees;
    if (+partialAmount > 0 && +partialAmount < maxAmount) {
      setErrorMsg("");
      setSendBtnDisabled(false);
      setAppliedFields({
        ...appliedFields,
        appliedPartialAmount: partialAmount,
      });
      callDiscountApi("", appliedFields?.appliedDiscount, partialAmount);
    } else {
      setErrorMsg(
        "Partial amount should be more than 0 and less than consultation fees"
      );
      setSendBtnDisabled(true);
    }
  };

  // <===

  // Display UI ===>

  const displayPartialPaymentUI = () => {
    return (
      <div className="review-and-share-partial-amount-container">
        {isOnlinePayment && appointmentDetails?.is_partial_payment_enabled && (
          <div className="review-and-share-partial-amount-checkbox">
            <CheckboxWithText
              label="Partial Payment"
              selected={isPartialPaymentSelected}
              handleChange={handleChangePartialPaymentCheckbox}
            />
          </div>
        )}
        {isPartialPaymentSelected && (
          <>
            <div className="review-and-share-partial-amount-input">
              <FormInputWithHeader
                type="number"
                value={partialAmount}
                placeholder="Enter your Amount"
                handleOnChangeInput={handleChangePartialAmount}
              />
              {partialAmount?.length !== 0 && (
                <div
                  className="review-and-share-partial-amount-apply-btn"
                  onClick={applyPartialPayment}
                >
                  Apply
                </div>
              )}
            </div>
            {errorMsg && (
              <div className="review-and-share-partial-amount-error">
                {errorMsg}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  // <===

  return (
    <>
      {fullPageLoader && <Loader />}
      {loader ? (
        <div className="text-center">
          <img src={require("../../assets/C2C Loader.gif")} />
        </div>
      ) : (
        <section className="reviewshare">
          <div className="row mt-3">
            <div className="col-12 text-center">
              <h2>Payment Summary</h2>
            </div>
          </div>
          <div className="row">
            <div className={colClasses}>
              <div className="row">
                <div className="col-lg-6 col-12 mt-4">
                  <h3>Full Name</h3>
                  <p className="details overflow-guard fnt-transcaps">
                    {appointmentDetails.patient_name}
                  </p>
                </div>
                {appointmentDetails.email && (
                  <div className="col-lg-6 col-12 mt-4">
                    <h3>Email</h3>
                    <p className="details">{appointmentDetails.email}</p>
                  </div>
                )}
                <div className="col-lg-6 col-12 mt-4">
                  <h3>Phone Number</h3>
                  <p className="details">{appointmentDetails.patient_phone}</p>
                </div>
                <div className="col-lg-6 col-12 mt-4">
                  {hasResourceAccess ||
                  (addBooking &&
                    selectedBookingType === BOOKING_TYPE.LABORATORY) ? (
                    <>
                      <h3>Consultation Date</h3>
                      <p className="details text-nowrap">
                        {moment(appointmentDetails.appointment_date).format(
                          "DD MMM YYYY"
                        )}
                      </p>
                    </>
                  ) : (
                    <>
                      <h3>Consultation Date &amp; Time</h3>
                      <p className="details text-nowrap">
                        {moment(appointmentDetails.appointment_date).format(
                          "DD MMM YYYY"
                        ) +
                          " at " +
                          moment(
                            appointmentDetails.start_time,
                            "hh:mm:ssZ"
                          ).format("hh:mm A")}
                      </p>
                    </>
                  )}
                </div>
                <div className="col-12 mt-4">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text d-none d-lg-flex">
                        Discount %
                      </span>
                      <span class="input-group-text d-flex d-lg-none">%</span>
                    </div>
                    <input
                      type="number"
                      class="form-control rm_bgfocus"
                      min="0"
                      max="100"
                      step="1"
                      maxLength="3"
                      placeholder="Enter Discount (optional)"
                      value={discountInput == 0 ? "" : discountInput}
                      onChange={handleDiscountInputChange}
                      disabled={hasAppliedDiscount} //|| !props.isAddMode
                    />
                    <div class="input-group-append">
                      {!hasAppliedDiscount ? (
                        <button
                          className="btn discount_btn_success"
                          type="button"
                          disabled={
                            discountInput == 0 || discountInput == ""
                              ? true
                              : false
                          }
                          onClick={() => {
                            applyDiscount("");
                          }}
                        >
                          Apply
                        </button>
                      ) : (
                        ""
                      )}
                      {hasAppliedDiscount ? (
                        <button
                          className="discount_btn_fail"
                          type="button"
                          onClick={removeDiscount}
                          // disabled={!props.isAddMode}
                        >
                          Remove
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className=""
                  style={{
                    display: "flex",
                    flex: "1",
                    justifyContent: "flex-end",
                    padding: "0px 15px",
                  }}
                >
                  <div class="button-group-pills" data-toggle="buttons">
                    {checkboxValue.map((data, index) => (
                      <label
                        class={`btn btn-default ${
                          data.checked ? "active" : ""
                        } ml-2`}
                        id={index}
                        style={{
                          fontWeight: "bold",
                          borderRadius: "12px",
                          width: "50px",
                          borderColor: "#56CDE8",
                          backgroundColor: data.checked ? "#56CDE8" : "#fff",
                        }}
                      >
                        {" "}
                        {/**active */}
                        <input
                          id={index}
                          type="checkbox"
                          name="options"
                          checked={data.checked}
                          onClick={(e) =>
                            !hasAppliedDiscount
                              ? handleCheckbox(e, data.id)
                              : ""
                          }
                        />
                        <div
                          style={{ color: data.checked ? "#fff" : "#56CDE8" }}
                        >
                          {data.name}
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
              {props.appointmentType === "in-clinic" && (
                <>
                  <div className="row">
                    <div className="col-lg-10 col-12 mt-3">
                      <h3>Payment Method</h3>
                    </div>
                  </div>
                  <div className="review-and-share-payment-methods">
                    <div className="row">
                      <div
                        style={{
                          marginLeft: !hasResourceAccess ? "0px" : "-10px",
                        }}
                        className="col-12 mt-2 d-flex flex-row icon-wrapper"
                      >
                        {
                          <button
                            class={
                              "btn btn-lg d-flex flex-column justify-content-center icon-card left " +
                              (isOnlinePayment ? "active-payment-mode" : "")
                            }
                            onClick={handleOnlinePaymentClick}
                          >
                            <i class="icon-credit-card mb-1"></i>
                            <span className="icon-label">Online via C2C</span>
                            <img className="okicon_img" src={okIcon} />
                          </button>
                        }
                        <button
                          class={
                            "btn btn-lg d-flex flex-column justify-content-center icon-card right " +
                            (!isOnlinePayment ? "active-payment-mode" : "")
                          }
                          onClick={handleCashPaymentClick}
                        >
                          <i class="icon-cash mb-1"></i>
                          <span className="icon-label">Pay at Clinic</span>
                          <img className="okicon_img" src={okIcon} />
                        </button>
                      </div>
                    </div>
                    {displayPartialPaymentUI()}
                  </div>
                </>
              )}
              {isOnlinePayment ? (
                <OnlinePayment
                  consultationFees={feeDetails?.consultation_fees}
                  hasAppliedDiscount={hasAppliedDiscount}
                  totalDiscount={feeDetails.total_discount}
                  partialPaymentFee={feeDetails?.partial_amount}
                  pendingAmount={feeDetails?.pending_amount}
                  gst={feeDetails?.gst_price}
                  convenienceFee={feeDetails?.convenience_fee}
                  totalFees={feeDetails?.total_fees}
                  phoneNumber={appointmentDetails.patient_phone}
                  totalCustomGst={feeDetails?.custom_gst_in_rupees}
                  handlePhoneOnChange={handlePhoneOnChange}
                  sendSMS={sendSMS}
                  handleResoureSubmit={handleResoureSubmit}
                  showTimer={showTimer}
                  phno={phno}
                  count={count}
                  counter={counter}
                  sendBtnDisabled={sendBtnDisabled}
                  appointmentType={props.appointmentType}
                  handleCashPaymentClick={handleCashPaymentClick}
                  procedureFeeList={procedureFeeList}
                  hasResourceAccess={hasResourceAccess}
                  addBooking={addBooking}
                  selectedBookingType={selectedBookingType}
                />
              ) : (
                <CashPayment
                  consultationFees={feeDetails.consultation_fees}
                  hasAppliedDiscount={hasAppliedDiscount}
                  totalDiscount={feeDetails.total_discount}
                  totalFees={feeDetails.total_fees}
                  procedureFeeList={procedureFeeList}
                  totalCustomGst={feeDetails?.custom_gst_in_rupees}
                  hasResourceAccess={hasResourceAccess}
                  addBooking={addBooking}
                  selectedBookingType={selectedBookingType}
                />
              )}
            </div>
          </div>
          <div className="row my-4">
            <div className="offset-lg-2 col-lg-8 col-12 d-flex justify-content-center mb-4">
              <button
                className="btn primary-cta-button rounded-pill py-2 px-5 button-style"
                disabled={proceedBtn || disabledProceedBtn}
                onClick={() => {
                  if (isOnlinePayment === true) {
                    handleSubmitClick();
                  } else if (isOnlinePayment === false) {
                    hasResourceAccess ||
                    (addBooking &&
                      selectedBookingType === BOOKING_TYPE.LABORATORY)
                      ? handleResoureSubmit()
                      : handleViaCash();
                  }
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
